(() => {
  if (customElements.get("product-images-carousel")) {
    return;
  }

  class ProductImagesCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || "default";
      this.shouldDestroyOnDesktop = this.hasAttribute("data-destroy");
      this.breakpoints = {
        desktop: 990,
      };
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener(
        "resize",
        debounce(this.toggleSwiperHandler.bind(this), 500),
      );
    }

    initSwiper() {
      this.swiperContainer = this.querySelector(
        ".product-images-carousel__slider",
      );
      this.progressbar = this.querySelector(".swiper-progress");
      const swiperNext = this.querySelector(
        ".product-images-carousel__control-next",
      );
      const swiperPrev = this.querySelector(
        ".product-images-carousel__control-prev",
      );

      const sizeCardSettings = {
        default: {
          pagination: {
            el: this.progressbar,
            type: "progressbar",
          },
          slidesPerView: "2.2",
          spaceBetween: 10,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: "3.2",
              spaceBetween: 10,
            },
          },
        },
        large: {
          slidesPerView: "2.2",
          spaceBetween: 10,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: "3.2",
              spaceBetween: 10,
            },
          },
        },
      };

      if (!this.swiperContainer) return;

      this.mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        speed: 300,
        ...sizeCardSettings[this.cardsSize],
      };

      this.swiper = new Swiper(this.swiperContainer, this.mainSettings);
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch {
        // Silently catch errors
      }
    }

    toggleSwiper(destroy) {
      if (destroy) {
        this.swiper.destroy(true, true);
      } else {
        this.swiper = new Swiper(this.swiperContainer, this.mainSettings);
      }
    }
  }

  customElements.define("product-images-carousel", ProductImagesCarousel);
})();
